"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function () {
  'use strict';

  function TripService($http, $q, $filter, Moment, DateService) {
    var getList = function getList() {
      var deferred = $q.defer();
      $http.get('/trips/list').then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    var getDetails = function getDetails(admincustDataId, transactionId) {
      var deferred = $q.defer();
      $http.get('/trips/detail/' + admincustDataId + '/' + transactionId).then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    var updateTrip = function updateTrip(modalObj) {
      var deferred = $q.defer();
      $http.put('/trips/update', modalObj).then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    var calculateTrip = function calculateTrip(transctionObj) {
      var deferred = $q.defer();
      $http.post('/trips/calculate', transctionObj).then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    var groupByStatus = function groupByStatus(tripArr) {
      var today = Moment().startOf('day');
      return tripArr.filter(function (trip) {
        var start = Moment(DateService.formatSlashesToDashes(trip.startDate));
        var end = Moment(DateService.formatSlashesToDashes(trip.endDate));

        if (trip.cancelDate) {
          trip.status = 'cancelled';
        } else if (today.diff(start, 'days', true) >= 0 && end.diff(today, 'days', true) >= 0) {
          trip.status = 'current';
        } else if (today.diff(start, 'days', true) < 0) {
          trip.status = 'upcoming';
        } else if (today.diff(end, 'days', true) > 0) {
          trip.status = 'past';
        }

        if (trip.status) {
          return trip;
        }
      }).reduce(function (prev, curr) {
        if (!prev.hasOwnProperty(curr.status)) {
          prev[curr.status] = [];
        }

        prev[curr.status].push(curr);
        return prev;
      }, {});
    };

    var helpers = {};

    helpers.getAvailableOptions = function (transction) {
      var _defaultOptions = transction.defaultOptions ? transction.defaultOptions.map(function (option) {
        option.categoryID = -1;
        option.categoryTitle = 'Reservation Options';
        return option;
      }) : [];

      var _customOptions = transction.customOptions ? transction.customOptions.map(function (option) {
        if (!option.categoryID) {
          option.categoryTitle = 'Reservation Options';
        }

        return option;
      }) : [];

      var packageSpecials = $filter('packageSpecials')(transction.specials);

      var _packages = packageSpecials ? packageSpecials.map(function (packageSpecial) {
        packageSpecial.categoryTitle = 'Packages';
        packageSpecial.type = 1;
        packageSpecial.name = packageSpecial.title;
        packageSpecial.preTaxTotal = packageSpecial.price;
        return packageSpecial;
      }) : [];

      return [].concat(_toConsumableArray(_defaultOptions), _toConsumableArray(_customOptions), _toConsumableArray(_packages)).filter(function (item) {
        return item.quantity === 0;
      });
    };

    helpers.groupOptionsByCategory = function (options) {
      var key = 'categoryTitle';
      return options.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };

    return {
      getList: getList,
      getDetails: getDetails,
      updateTrip: updateTrip,
      calculateTrip: calculateTrip,
      groupByStatus: groupByStatus,
      helpers: helpers
    };
  }

  TripService.$inject = ['$http', '$q', '$filter', 'Moment', 'DateService'];
  angular.module('trip-service', []).service('TripService', TripService);
})();